import { elementShortNames } from "./constants"
import moment from 'moment'
type ElementShortNameValue = {
    stem: string;
    shortName: string;
}

interface ElementShortNames {
    [key: string]: {
        stem: string;
        shortName: string;
    }
}

export const getElementShortName = (elementName?: string | null | undefined): string | null | undefined => {
    if (!elementName) return elementName;

    const allNames = elementShortNames.ALL as ElementShortNames;
    const stem = Object.values(allNames) 
        .find(({ stem }: ElementShortNameValue) => elementName.includes(stem)) as ElementShortNameValue;

    if (stem) return elementName.replace(stem.stem, stem.shortName);
    return elementName;
}

export const getLongDate = (date: string | Date) => new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

export const getShortDate = (date: string | Date) => moment(date).format('MMM Do, YYYY')
